class RequestType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`settings.request-rates-and-limits.request-type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(requestType) {
        return requestType === this;
    }
}

export const ANY = new RequestType('ANY');
export const EXPENSIVE = new RequestType('EXPENSIVE');
export const ADMIN = new RequestType('ADMIN');

export const getRequestType = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'ANY':
            result = ANY;
            break;
        case 'EXPENSIVE':
            result = EXPENSIVE;
            break;
        case 'ADMIN':
            result = ADMIN;
            break;
        default:
            throw new Error(`Unknown request type: ${serverType}`);
    }
    return result;
};

export const getAllRequestTypes = () => [
    ANY,
    EXPENSIVE,
    ADMIN,
];
